//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";

export default {
  async mounted() {
    await this.loaddata();
    await this.loaddepartment();
    await this.loadposition();
    this.$hideLoader();
  },
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      defaultwordbuttonsig1: "My Signature",
      showbuttonsavesig1: false,
      showsig1: false,
      showpreviewimage: null,
      preview_image: null,
      image_data: null,
      dataaccount: [],
      datadepartment: [],
      dataposition: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      isShowCurrentPassword: false,
      isShowPassword: false,
      isShowPassword2: false,
      // ตัวควบคุมการแสดงช่อง New/Confirm Password (Current Password จะแสดงตลอด)
      showChangePassword: false,
      account: {
        currentpassword: "",
        password: "",
        confirm_password: "",
        phone: "",
        signature: "",
        oldimage: "",
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    // เปิด/ปิดโหมดเปลี่ยนรหัสผ่าน (เฉพาะ New/Confirm) และล้างค่าฟิลด์รหัสผ่านใหม่เมื่อยกเลิก
    // ตรวจรูปแบบรหัสผ่านใหม่: 8+ ตัวอักษร, มีตัวพิมพ์เล็ก-ใหญ่, ตัวเลข, อักขระพิเศษ
    isValidPassword(pwd) {
      const rule = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
      return rule.test(pwd);
    },
    toggleChangePassword() {
      this.showChangePassword = !this.showChangePassword;
      if (!this.showChangePassword) {
        this.account.password = "";
        this.account.confirm_password = "";
      }
    },
    async showdefaultsignature() {
      this.$nextTick(() => {
        this.$refs.firstsignaturePad.resizeCanvas();
        this.$refs.firstsignaturePad.fromDataURL(this.account.signature);

        this.$refs.firstsignaturePad.lockSignaturePad();
        this.$refs.firstsignaturePad.resizeCanvas();
        this.$refs.firstsignaturePad.lockSignaturePad();
      });
    },
    async clearsig1() {
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.clearSignature();
      this.account.signature = "";
    },
    async savesig1() {
      this.defaultwordbuttonsig1 = "Edit";
      this.showbuttonsavesig1 = false;

      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.account.signature = data;
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.account.signature);
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
    },
    editsig1() {
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.account.signature);
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_image = e.target.result;
            this.getImage(e.target.result, "preview");
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_data = input.files[index];
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
    },
        async loaddepartment() { 
        const result = await api.getDepartmentByID(
        this.dataaccount.department_i_d??0
        );
        this.datadepartment = result.data[0];
        },
        async loadposition() { 
        const result = await api.getAllPositionTranning(
        this.dataaccount.company_i_d??0 ,Number(this.dataaccount.department_i_d)??0
        );
        if (result.data.length > 0) {
        this.dataposition = result.data.find(item => String(item.id) === String(this.dataaccount.position_i_d));
        }
        },
    async loaddata() {
      const result = await api.getAccountid(
        localStorage.getItem(server.USER_ID)
      );
      if (result.data[0]) {
        this.dataaccount = result.data[0];
        this.account.phone = this.dataaccount.phone;
        this.account.signature = this.dataaccount.signature;
        this.account.oldimage = this.dataaccount.image || "";
        await this.getImage(null, "load");
        await this.showdefaultsignature();
        this.showsig1 = true;
      }
    },
    async getImage(data, type) {
      if (type == "load") {
        // กันทั้งกรณี image เป็น null/undefined/ว่างจริง และกรณี string "null"/"undefined"
        // ที่อาจหลงเหลืออยู่ใน DB จาก FormData แปลง null เป็น string ผิดพลาดในอดีต
        const img = this.dataaccount.image;
        if (!img || img === "null" || img === "undefined") {
          this.showpreviewimage = null;
          return null;
        }
        this.showpreviewimage = `${imageUrl}/${img}`;
        return `${imageUrl}/${img}`;
      } else {
        this.showpreviewimage = `${data}`;
        return `${data}`;
      }
    },
    // เรียกเมื่อ v-img โหลดรูปจริงไม่สำเร็จ (URL 404 / เสีย) ให้ fallback กลับไปเป็นรูป default
    onAvatarError() {
      this.showpreviewimage = null;
    },
    async submit() {
      // Current Password ต้องกรอกเสมอ ใช้ยืนยันตัวตนก่อนบันทึกทุกการเปลี่ยนแปลง (ทั้งข้อมูลส่วนตัวและรหัสผ่าน)
      if (this.account.currentpassword == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Current Password",
          "text-h5 red--text text-center"
        );
        return;
      }

      // ตรวจสอบฟิลด์รหัสผ่านใหม่ เฉพาะกรณีเปิดโหมดเปลี่ยนรหัสผ่านเท่านั้น
      if (this.showChangePassword) {
        if (this.account.password == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Input New Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.confirm_password == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Input Confirm Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (!this.isValidPassword(this.account.password)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Password format invalid",
            "Password must contain: • 8+ characters • Uppercase and lowercase letters • A number • A special character",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.password == this.account.currentpassword) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "New Password must not be the same as Current Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.password != this.account.confirm_password) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Password and Confirm Password not match",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      let formData = new FormData();
      if (this.image_data) {
        formData.append("image", this.image_data);
      }
      // ส่ง currentpassword ไปยืนยันตัวตนเสมอ ส่ง password ใหม่เฉพาะกรณีเปิดโหมดเปลี่ยนรหัสผ่าน
      formData.append("currentpassword", this.account.currentpassword);
      if (this.showChangePassword && this.account.password !== "") {
        formData.append("password", this.account.password);
      }
      formData.append("phone", this.account.phone);
      formData.append("signature", this.account.signature);
      formData.append("oldimage", this.account.oldimage || "");
      this.$showLoader();
      try {
        const res_reset = await api.updateMyprofileWebv2(
          localStorage.getItem(server.USER_ID),
          formData
        );

        // backend ตอบ HTTP 200 เสมอทุกกรณี (สำเร็จ/ไม่สำเร็จ) เพื่อเลี่ยง interceptor ที่ดัก
        // non-2xx แล้ว redirect ไป dashboard/logout ผลลัพธ์จริงต้องดูจาก data.ok แทน
        if (res_reset.data && res_reset.data.ok) {
          // ต้องจับค่านี้ไว้ก่อน เพราะด้านล่างจะรีเซ็ต showChangePassword เป็น false ทันที
          const passwordWasChanged = this.showChangePassword;

          this.$hideLoader()
          this.$store.state.global_dialog = true;

          // ล้างฟิลด์รหัสผ่านทุกกรณีหลังบันทึกสำเร็จ เพื่อความปลอดภัย
          this.account.currentpassword = "";
          this.account.password = "";
          this.account.confirm_password = "";
          this.showChangePassword = false;
          this.image_data = null;

          if (passwordWasChanged) {
            // กรณีเปลี่ยนรหัสผ่านสำเร็จ -> ต้องบังคับ logout ทันที ไม่ reload ข้อมูลต่อ
            // เพราะ session/token เดิมควรถือว่าไม่ปลอดภัยอีกต่อไปหลังรหัสผ่านเปลี่ยน
            this.setupAlertDialogPush(
              true,
              "Success",
              "เปลี่ยนรหัสผ่านสำเร็จ ระบบจะให้คุณเข้าสู่ระบบใหม่อีกครั้ง",
              "text-h5 green--text text-center",
            );
            this.forceLogoutAfterPasswordChange();
            return;
          }

          this.setupAlertDialogPush(
            true,
            "Success",
            "Update data success",
            "text-h5 green--text text-center",
          );

          // โหลดข้อมูลล่าสุด (เช่น เบอร์โทร, รูปโปรไฟล์ที่เพิ่งอัปโหลด) กลับมาแสดงใหม่
          this.$showLoader();
          await this.loaddata();
          this.$hideLoader();
        } else {
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            this.mapErrorMessage(res_reset),
            "text-h5 red--text text-center"
          );
        }
      } catch (error) {
        // ดักกรณีเรียก API ไม่สำเร็จ (network error, timeout ฯลฯ) ไม่ให้หน้าจอค้างเฉยๆ
        this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          this.mapErrorMessage(error && error.response ? error.response : null),
          "text-h5 red--text text-center"
        );
      }
    },
    // แปล message จาก backend ให้เป็นข้อความที่ user เข้าใจง่าย
    // (backend ตอบ HTTP 200 เสมอทุกกรณีแล้ว จึงอิงจาก "เนื้อหา message" ล้วนๆ ไม่ใช่ status code)
    mapErrorMessage(res) {
      const backendMessage = res && res.data && res.data.message ? res.data.message : "";

      if (/current password/i.test(backendMessage)) {
        return "รหัสผ่านปัจจุบันไม่ถูกต้อง";
      }
      if (/account not found/i.test(backendMessage)) {
        return "ไม่พบข้อมูลบัญชีผู้ใช้งาน";
      }
      if (backendMessage) {
        return backendMessage;
      }
      return "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
    },
    // บังคับ logout หลังเปลี่ยนรหัสผ่านสำเร็จ หน่วงเวลาสั้นๆ ให้ user เห็น dialog สำเร็จก่อน redirect
    // *** สมมติฐาน: ล้าง localStorage แล้วเด้งไปหน้า /login เพราะไม่รู้ว่าระบบจริงมี
    // action logout ของ store หรือ api.logout() อยู่แล้วหรือไม่ ถ้ามีอยู่แล้วรบกวนบอก
    // จะได้เปลี่ยนมาเรียกอันนั้นแทน เพื่อให้ล้าง state อื่นๆ (เช่น user profile ใน store) ครบด้วย ***
    forceLogoutAfterPasswordChange() {
      setTimeout(() => {
        localStorage.removeItem(server.USER_ID);
        localStorage.removeItem("token");
        this.$router.push("/login");
      }, 1800);
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
